// Store per gestire il flusso Quick Registration V3
// Mantiene temporaneamente i dati utente tra verifica email e modifica password

export const state = () => ({
  tempUser: null, // Dati utente temporanei da verify-email
  isQuickRegFlow: false, // Flag per indicare se siamo nel flusso quick reg
})

export const mutations = {
  setTempUser(state, user) {
    console.log('[QUICK-REG-STORE] setTempUser:', user)
    state.tempUser = user
    state.isQuickRegFlow = true
  },

  clearTempUser(state) {
    console.log('[QUICK-REG-STORE] clearTempUser')
    state.tempUser = null
    state.isQuickRegFlow = false
  },
}

export const getters = {
  hasQuickRegUser: (state) => !!state.tempUser,
  quickRegUser: (state) => state.tempUser,
  isQuickRegFlow: (state) => state.isQuickRegFlow,
}

export const actions = {
  saveTempUser({ commit }, user) {
    commit('setTempUser', user)
  },

  clear({ commit }) {
    commit('clearTempUser')
  },
}
